/* eslint-disable react/no-unknown-property */
import { FC } from 'react';
import './pype-preview.scss';

const iconHome = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="16" cy="16" r="16"></circle>
      <path
        fill="currentColor"
        opacity="1"
        d="M22 14c.552 0 1 .448 1 1v7c0 .513-.386.936-.883.993L22 23H10c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1s1 .448 1 1l-.001 6H21v-6c0-.552.448-1 1-1zm-5.967-6.5c.165.003.33.046.483.134l8.66 5c.479.276.643.888.367 1.366-.277.478-.888.642-1.366.366l-8.179-4.722-8.178 4.722c-.478.276-1.09.112-1.366-.366s-.112-1.09.366-1.366l8.66-5c.153-.088.319-.131.483-.134h.07z"
      ></path>
    </g>
  </svg>
);

const iconMinus = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="16" cy="16" r="16"></circle>
      <rect
        width="16"
        height="2"
        x="8"
        y="15"
        fill="currentColor"
        opacity="1"
        rx="1"
      ></rect>
    </g>
  </svg>
);

const iconClose = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="16" cy="16" r="16"></circle>
      <path
        fill="currentColor"
        opacity="1"
        d="M11.757 10.343L16 14.585l4.244-4.242c.39-.39 1.023-.39 1.414 0 .39.39.39 1.024 0 1.414L17.414 16l4.243 4.244c.39.39.39 1.023 0 1.414-.39.39-1.024.39-1.414 0l-4.244-4.243-4.242 4.243c-.39.39-1.023.39-1.414 0-.39-.39-.39-1.024 0-1.414l4.242-4.244-4.242-4.242c-.39-.39-.39-1.023 0-1.414.39-.39 1.024-.39 1.414 0z"
      ></path>
    </g>
  </svg>
);

const bubbleTail = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13px"
    height="13px"
    viewBox="0 0 13 10"
    fill="none"
  >
    <defs>
      <filter id="8ba5fjts7a">
        <feColorMatrix in="SourceGraphic"></feColorMatrix>
      </filter>
    </defs>
    <g filter="url(#8ba5fjts7a)">
      <g>
        <path
          d="M13.032 0l-9.64 9.35c-.792.768-2.059.749-2.828-.044C.202 8.933 0 8.433 0 7.914V0h13.032z"
          fill="currentColor"
        ></path>
      </g>
    </g>
  </svg>
);

const iconNext = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    fill="none"
  >
    <g fill="none" fillRule="evenodd" transform="translate(36,36)">
      <g transform="translate(-36,-36)">
        <path
          fill="currentColor"
          opacity="1"
          d="M24.986 15.137L9.776 7.98c-.312-.147-.681-.101-.948.118-.267.22-.384.573-.3.908l1.084 4.338 6.94 2.603-6.94 2.603-1.084 4.338c-.086.335.03.69.298.91.268.22.638.265.95.116l15.21-7.157c.314-.148.514-.463.514-.81 0-.347-.2-.662-.514-.81z"
        ></path>
      </g>
    </g>
  </svg>
);

interface PypePreviewProps {
  widgetStyleColor: string;
  widgetStyleTextColor: string;
  agentBubbleColor: string;
  agentBubbleTextColor: string;
  userBubbleColor: string;
  userBubbleTextColor: string;
  buttonColor: string;
  buttonTextColor: string;
  logo?: string;
  brandMomentUrl?: string;
}

export const PypePreview: FC<PypePreviewProps> = ({
  widgetStyleColor,
  widgetStyleTextColor,
  agentBubbleColor,
  agentBubbleTextColor,
  userBubbleColor,
  userBubbleTextColor,
  buttonColor,
  buttonTextColor,
  logo,
  brandMomentUrl,
}) => {
  return (
    <div
      test-id="ps-channel-details-pype-preview"
      className="c-pype-preview"
      style={
        {
          '--preview-pype-brand-color': widgetStyleColor,
          '--preview-pype-brand-text-color': widgetStyleTextColor,
          '--preview-pype-solution-buble-color': agentBubbleColor,
          '--preview-pype-solution-buble-text-color': agentBubbleTextColor,
          '--preview-pype-user-buble-color': userBubbleColor,
          '--preview-pype-user-buble-text-color': userBubbleTextColor,
          '--preview-pype-button-color': buttonColor,
          '--preview-pype-button-text-color': buttonTextColor,
        } as React.CSSProperties
      }
    >
      <div
        className={`c-pype-preview__nav ${brandMomentUrl ? 'c-pype-preview__nav--has-banner' : ''}`}
        style={{
          backgroundImage: brandMomentUrl ? `url(${brandMomentUrl})` : 'none',
        }}
      >
        <div className="c-pype-preview__nav-inner">
          <div className="c-pype-preview__icon-btn">{iconHome}</div>
          <div className="c-pype-preview__icon-btn">{iconMinus}</div>
          <div className="c-pype-preview__icon-btn">{iconClose}</div>
        </div>
      </div>
      <div className="c-pype-preview__main">
        <div className="c-pype-preview__header">
          <div className="c-pype-preview__header-icon">
            {logo && <img src={logo} alt="" width={32} height={32} />}
          </div>
          <div className="c-pype-preview__header-title">Test Widget</div>
        </div>
        <div className="c-pype-preview__body">
          <div className="c-pype-preview__info">Today At 7:44 PM</div>
          <div className="c-pype-preview__bubble">
            Greetings! This is the first node in the solution.
            {bubbleTail}
          </div>
          <div className="c-pype-preview__bubble c-pype-preview__bubble--user">
            Mostafa
            {bubbleTail}
          </div>
          <div className="c-pype-preview__bubble">
            You selected <b>Mostafa!</b>
            {bubbleTail}
          </div>
          <div className="c-pype-preview__bubble">
            Greetings! This is the first node in the solution.
            {bubbleTail}
          </div>
          <div className="c-pype-preview__btn-group">
            <div className="c-pype-preview__btn">Jake</div>
            <div className="c-pype-preview__btn">Calin</div>
            <div className="c-pype-preview__btn">Mostafa</div>
          </div>
        </div>
        <div className="c-pype-preview__controls">
          <div className="c-pype-preview__controls-input">
            Select option or type message
          </div>
          <div className="c-pype-preview__controls-btn">{iconNext}</div>
        </div>
      </div>
    </div>
  );
};
